import type {IRange} from "@pg-design/inputs-module";

import type {IRegionListRegion} from "../../search/actions/fetch_search_regions_action";
import {SearchTab} from "../../search/types/SearchTab";

export enum PhoneType {
    Whatsapp,
    Sms,
    None
}

export interface IOfferNotificationChatBotFormValues {
    search: {
        label: string;
        tabType: SearchTab.Regions;
        regions: IRegionListRegion[];
    };
    rooms: IRange<number | "">;
    phone_type: PhoneType;
    phone: {
        code: number;
        number: string;
    };
    general_marketing_consent: boolean;
}
import type {IRange} from "@pg-design/inputs-module";

import type {IRegionListRegion} from "../../search/actions/fetch_search_regions_action";
import {SearchTab} from "../../search/types/SearchTab";

export enum PhoneType {
    Whatsapp,
    Sms,
    None
}

export interface IOfferNotificationChatBotFormValues {
    search: {
        label: string;
        tabType: SearchTab.Regions;
        regions: IRegionListRegion[];
    };
    rooms: IRange<number | "">;
    phone_type: PhoneType;
    phone: {
        code: number;
        number: string;
    };
    general_marketing_consent: boolean;
}
